import React, { useState, useEffect } from "react";
import {
  ChakraProvider,
  Box,
  Card,
  Container,
  Center,
  Button,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormErrorMessage,
  Input,
  Heading,
  VStack,
  RadioGroup,
  Radio,
  Select,
  HStack,
  Grid,
  GridItem,
  useColorModeValue,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { ColorModeSwitcher } from "../ColorModeSwitcher";
import { Nav } from "../containers/Nav";
import { userLogin, userRegister } from "../actions/auth";
import PrivacyPolicy from "../components/privacyPolicy";
import { useNavigate } from "react-router-dom";

function Login() {
  const navigate = useNavigate();
  useEffect(() => {
    if (localStorage.getItem("jwtToken")) {
      return navigate(`/home`);
    }
  });

  const lightGray = useColorModeValue("gray.600", "gray.100");

  const [loginEmail, setLoginEmail] = useState("");
  const [loginPass, setLoginPass] = useState("");
  const [loginEmailErr, setLoginEmailErr] = useState();
  const [loginPassErr, setLoginPassErr] = useState();
  const [loginErr, setLoginErr] = useState("");

  const [registerFirstName, setRegisterFirstName] = useState("");
  const [registerLastName, setRegisterLastName] = useState("");

  const [registerPassword, setRegisterPassword] = useState("");
  const [registerPhone, setRegisterPhone] = useState("");
  const [registerEmail, setRegisterEmail] = useState("");
  const [registerBirthday, setRegisterBirthday] = useState("");
  const [registerGender, setRegisterGender] = useState("");

  const [registerErrors, setRegisterErrors] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const onClose = () => {
    setIsOpen(false);
  };

  const submitRegistration = async () => {
    setRegisterErrors([]);
    let errors = [];
    if (!registerFirstName) {
      errors.push("First name is a required field");
    }
    if (!registerLastName) {
      errors.push("Last name is a required field");
    }
    if (!registerEmail) {
      errors.push("Email is a required field");
    }
    if (!registerPassword) {
      errors.push("Password is a required field");
    }
    if (!registerBirthday) {
      errors.push("Birth date is a required field");
    }
    if (!registerGender) {
      errors.push("Gender is a required field");
    }

    if (errors.length) {
      setRegisterErrors([...errors]);
      return;
    }

    try {
      const registrationAttempt = await userRegister({
        firstName: registerFirstName,
        lastName: registerFirstName,
        email: registerEmail,
        password: registerPassword,
        birthDate: registerBirthday,
        gender: registerGender,
        phone: registerPhone,
      });

      if (registrationAttempt) {
        const loginAttempt = await userLogin(registerEmail, registerPassword);
        localStorage.setItem("jwtToken", loginAttempt.token);
        localStorage.setItem("register_user_profile", true);
        return navigate(`/userProfile`);
      }
    } catch (err) {
      console.log(err);
      let errors = [];
      Object.keys(err).map((e) => {
        errors.push(err[e]);
      });
      setRegisterErrors(errors);
    }
  };

  const submitLogin = async () => {
    setLoginEmailErr("");
    setLoginPassErr("");
    let errors = false;
    if (!loginEmail) {
      setLoginEmailErr("Email is required to login");
      errors = true;
    } else if (!loginEmail.includes("@") || !loginEmail.includes(".")) {
      setLoginEmailErr("Email address is invalid");
      errors = true;
    }
    if (!loginPass) {
      setLoginPassErr("Password is required to login");
      errors = true;
    }

    if (errors) {
      return;
    }

    try {
      const loginAttempt = await userLogin(loginEmail, loginPass);

      localStorage.setItem("jwtToken", loginAttempt.token);

      const jwt = loginAttempt.token.split("Bearer ")[1];
      const payload = atob(jwt.split(".")[1]);
      const parsedJWT = JSON.parse(payload);
      if (parsedJWT.isAdmin) {
        return navigate("/admin/campaigns");
      }

      return navigate("/home");
    } catch (err) {
      console.log(err);
      setLoginErr(err);
    }
  };

  return (
    <Grid
      templateAreas={`"header header" "main main" "footer footer"`}
      gridTemplateRows={"50px 1fr 30px"}
      gridTemplateColumns={"150px 1fr"}
      h="200px"
      color="blackAlpha.700"
    >
      <Nav page={"login"} />

      <GridItem pl="2" area={"main"}>
        <VStack>
          <Box mt="8">
            <Heading
              color={useColorModeValue("gray.1000", "gray.100")}
              fontSize="2xl"
            >
              Welcome to Hubit!
            </Heading>
          </Box>

          <Card
            mx="5"
            my="5"
            p="45px"
            minW="2xl"
            bg={useColorModeValue("gray.100", "gray.900")}
            align="top"
          >
            <HStack>
              <form>
                <Box
                  width="100%"
                  px="6"
                  borderRight="1px"
                  borderColor="gray.200"
                >
                  <Center>
                    <Heading fontSize="lg">Create an Account</Heading>
                  </Center>

                  <Container mt="6">
                    <HStack>
                      <Box width="100%">
                        <Input
                          variant="flushed"
                          type="text"
                          value={registerFirstName}
                          onChange={(e) => setRegisterFirstName(e.target.value)}
                          placeholder="Name"
                        />
                      </Box>

                      <Box width="100%">
                        <Input
                          variant="flushed"
                          type="text"
                          value={registerLastName}
                          onChange={(e) => setRegisterLastName(e.target.value)}
                          placeholder="Last name"
                        />
                      </Box>
                    </HStack>

                    <Box width="100%" my="4">
                      <Input
                        variant="flushed"
                        type="text"
                        value={registerEmail}
                        onChange={(e) => setRegisterEmail(e.target.value)}
                        placeholder="Email address"
                      />
                    </Box>

                    <Box width="100%" my="4">
                      <Input
                        variant="flushed"
                        type="password"
                        value={registerPassword}
                        onChange={(e) => setRegisterPassword(e.target.value)}
                        placeholder="Password"
                      />
                    </Box>

                    <Box width="100%" my="4">
                      <Input
                        variant="flushed"
                        type="tel"
                        value={registerPhone}
                        onChange={(e) => setRegisterPhone(e.target.value)}
                        placeholder="Phone number"
                      />
                    </Box>

                    <HStack>
                      <Box width="100px">
                        <Text color="gray.500">Birth date:</Text>
                      </Box>

                      <Box width="100%">
                        <Input
                          variant="flushed"
                          onChange={(e) => setRegisterBirthday(e.target.value)}
                          value={registerBirthday}
                          placeholder="Birthday"
                          size="md"
                          type="date"
                        />
                      </Box>
                    </HStack>

                    <HStack>
                      <Box width="80px" my="4">
                        <Text color="gray.500">Gender:</Text>
                      </Box>

                      <Box width="100%">
                        <RadioGroup
                          onChange={(e) => setRegisterGender(e)}
                          value={registerGender}
                        >
                          <HStack>
                            <Radio value="male">Male</Radio>
                            <Radio value="female">Female</Radio>
                            <Radio value="other">Other</Radio>
                          </HStack>
                        </RadioGroup>
                      </Box>
                    </HStack>
                  </Container>

                  <Box width="100%" mt="6">
                    <Center>
                      <Button
                        isDisabled={
                          !registerFirstName ||
                          !registerLastName ||
                          !registerEmail ||
                          !registerPassword ||
                          !registerBirthday ||
                          !registerPhone ||
                          !registerGender
                        }
                        colorScheme="green"
                        type="submit"
                        width="100%"
                        onClick={async (e) => {
                          e.preventDefault();
                          await submitRegistration();
                        }}
                      >
                        Sign Up
                      </Button>
                    </Center>
                    <Center>
                      <Box>
                        <Text fontSize="xs" mt="2">
                          By signing up, you agree to our{" "}
                          <Link onClick={() => setIsOpen(true)}>
                            <Text as="u" color="teal">
                              Privacy Policy
                            </Text>
                          </Link>
                        </Text>
                      </Box>
                    </Center>
                    {registerErrors.length > 0 &&
                      registerErrors.map((err) => {
                        return (
                          <Center>
                            <Box>
                              <Text color="red.500">{err}</Text>
                            </Box>
                          </Center>
                        );
                      })}
                  </Box>
                </Box>
              </form>

              <Box align="top" width="100%">
                <Center>
                  <Text fontSize="lg">
                    Already have an account? <Text as="b">Sign In:</Text>
                  </Text>
                </Center>

                <form>
                  <Box width="100%" my="4" px="5">
                    <FormControl isInvalid={loginEmailErr}>
                      <Input
                        variant="flushed"
                        type="text"
                        value={loginEmail}
                        onChange={(e) => setLoginEmail(e.target.value)}
                        placeholder="Email"
                      />
                      <FormErrorMessage>{loginEmailErr}</FormErrorMessage>
                    </FormControl>
                  </Box>

                  <Box width="100%" my="2" px="5">
                    <FormControl isInvalid={loginPassErr}>
                      <Input
                        variant="flushed"
                        type="password"
                        value={loginPass}
                        onChange={(e) => setLoginPass(e.target.value)}
                        placeholder="Password"
                      />
                      <FormErrorMessage>{loginPassErr}</FormErrorMessage>
                    </FormControl>
                  </Box>

                  <Box width="100%" mt="6">
                    <Center>
                      <Button
                        type="submit"
                        onClick={async (e) => {
                          e.preventDefault();
                          await submitLogin();
                        }}
                        isDisabled={!loginEmail || !loginPass}
                        colorScheme="blue"
                      >
                        Sign In
                      </Button>
                    </Center>
                    {loginErr && (
                      <Center>
                        {Object.keys(loginErr).map((key) => {
                          return (
                            <Box>
                              <Text color="red.500">{loginErr[key]}</Text>
                            </Box>
                          );
                        })}
                      </Center>
                    )}
                  </Box>
                </form>
              </Box>
            </HStack>
          </Card>
          <Text color={lightGray} fontSize="sm">
            Are you a Production company?{" "}
            <Link to="/loginBrand">
              <Text color="teal" as="u">
                Click here
              </Text>
            </Link>{" "}
            to use the Production company login/signup
          </Text>
        </VStack>
      </GridItem>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Heading fontSize="xl">Hubit Privacy Policy</Heading>
          </ModalHeader>
          <ModalCloseButton />
          <PrivacyPolicy />
          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>

      {/*
      <GridItem area={'footer'}>
        <Box
          p="30px"
          width="100%"
          bg={useColorModeValue('gray.600', 'gray.600')}
          color={useColorModeValue('gray.100', 'gray.100')}
        >
          <Center>
            <Text>Copyright © {new Date().getFullYear()} Hubit</Text>
          </Center>
        </Box>
      </GridItem>
      */}
    </Grid>
  );
}

export default Login;
